import React from "react";
import { Home, Search, ShoppingBag, User } from "lucide-react";

/* THE customer bottom navigation: one floating glassmorphic capsule, reused by every primary
   customer surface. It only switches the existing destinations (home route, the canonical search
   field, the existing orders sheet, the existing profile sheet) — no new state or data flow. */
export default function CustomerBottomNav({ active = "home", onHome, onSearch, onOrders, onProfile, t }) {
  const items = [
    { key: "home", Icon: Home, label: t("nav.home", "Početna"), onClick: onHome },
    { key: "search", Icon: Search, label: t("nav.search", "Pretraga"), onClick: onSearch },
    { key: "orders", Icon: ShoppingBag, label: t("nav.orders", "Porudžbine"), onClick: onOrders },
    { key: "profile", Icon: User, label: t("nav.profile", "Profil"), onClick: onProfile },
  ];
  return (
    <nav data-testid="customer-bottom-nav" aria-label={t("nav.aria", "Glavna navigacija")}
      className="ponesi-bottomnav">
      <ul className="flex items-center gap-1.5">
        {items.map(({ key, Icon, label, onClick }) => (
          <li key={key}>
            <button type="button" onClick={onClick} aria-label={label} title={label}
              aria-current={active === key ? "page" : undefined}
              data-testid={`nav-${key}`}
              className={`w-12 h-12 rounded-full flex items-center justify-center transition-all active:scale-95 ${
                active === key ? "bg-white/30 text-white shadow-inner" : "text-white/85 hover:bg-white/15"}`}>
              <Icon size={22} strokeWidth={2.2} />
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
